<template>
  <div class="exhibition">
    <common-layout>
      <div slot="header">
        <h3>展览展示</h3>
      </div>
      <div slot="container">
        <div class="exhibition-header">
          <div class="exhibition-search">
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="add"
              style="background: #623AA2; border: none;"
            >新增</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
            <el-input
              placeholder="请输入内容"
              v-model="searchValue"
              class="input-with-select"
              @keyup.enter.native="search"
              clearable
              @clear="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </div>
          <el-button type="warning" @click="back">返回上一页</el-button>
        </div>
        <div class="exhibition-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>
                  {{
                  scope.$index + (currentPage - 1) * per_page + 1
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="展品名称" align="center" prop="title"></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.isPublish == 2"
                >确认发布</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消发布</el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog :title="Title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="展品名称" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>

        <el-form-item label="展品图片" prop="image" style="text-align:center">
          <el-upload
            style="text-align:left"
            :action="this.uploadURL"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="pictureCardPreview"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :http-request="HouImgFile"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="时间" prop="dateTime">
          <el-date-picker
            :picker-options="pickerOptions"
            v-model="ruleForm.dateTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择日期"
            style="text-align: left;width:100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="展品简介" prop="introduction">
          <el-input type="textarea" v-model="ruleForm.introduction" placeholder="请输入简介" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="是否发布" prop="isPublish" style="text-align:left">
          <el-switch
            v-model="ruleForm.isPublish"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="2"
          ></el-switch>
        </el-form-item>
        <div style="text-align:right;margin-top:10px">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="closeForm('ruleForm')">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import { DisabledDateFn } from "../../utils/tool";

export default {
  components: { CommonLayout },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      themeId: "",
      total: 10,
      per_page: 10,
      currentPage: 1,
      Title: "",
      dialogFormVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      searchValue: "",
      deleteRow: "",
      fileList: [],
      tableData: [],
      ruleForm: {
        themeId: "",
        title: "",
        image: "",
        introduction: "",
        isPublish: 2,
        dateTime: "",
      },
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        introduction: [
          { required: true, message: "请输入简介", trigger: "blur" },
        ],
        dateTime: [
          {
            type: "string",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.themeId = this.$route.params.id;
    this.getData(`Service_Display_Exhibit?themeId=${this.themeId}`);
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-exhibit/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.currentPage = res.data.current_page;
          this.per_page = res.data.per_page;
        }
      });
    },
    back() {
      this.$router.push("/serviceInnovate/exhibition");
    },
    //新增
    add() {
      this.is_submit = true

      this.dialogFormVisible = true;
      this.Title = "新建展品";
      this.ruleForm = {
        themeId: "",
        title: "",
        image: "",
        introduction: "",
        isPublish: 2,
        dateTime: "",
      };
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true
      this.dialogFormVisible = true;
      this.Title = "编辑展品";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      if (row.image) {
        let arr = [];
        arr = row.image.split(",");
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if(!this.is_submit) {
          return
        }
        this.is_submit = false;
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          obj.themeId = this.themeId;
          let arr = [];
          this.fileList.forEach((item) => {
            if (item.response) {
              arr.push(item.response.data.store_result);
            } else {
              arr.push(item.store_result);
            }
          });
          obj.image = arr.join(",");
          if (this.Title == "新建展品") {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-exhibit/create`, obj).then((res) => {
              if (res.code == 0) {
				this.ResetSearch(["searchValue"]);

                this.$message.success("新建成功");
                this.getData(
                  `Service_Display_Exhibit?themeId=${this.themeId}`
                );
                this.fileList = [];
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              }
            }).catch(err => {
              this.is_submit = true
            });
          }
          if (this.Title == "编辑展品") {
				this.ResetSearch(["searchValue"]);

            // delete obj.id;
            obj.id = this.ruleForm.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-exhibit/update`, obj)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("编辑成功");
                  this.getData(
                    `Service_Display_Exhibit?themeId=${this.themeId}`
                  );
                  this.fileList = [];
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                }
              }).catch (err => {
              this.is_submit = true

              });
          }
        } else {
              this.is_submit = true
          
          return false;
        }
      });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
      this.fileList = [];
    },
    //发布
    release(row) {
      let data = {};
      if (row.isPublish == 1) {
        data.isPublish = 2;
      } else if (row.isPublish == 2) {
        data.isPublish = 1;
      }
      data.id = row.id;
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-exhibit/update`, data).then((res) => {
        if (res.code == 0) {
          if (data.isPublish == 1) {
            this.$message.success("发布成功");
          } else {
            this.$message.info("已取消发布");
          }
          this.getData(
            `Service_Display_Exhibit?themeId=${this.themeId}&page=${this.currentPage}&title=${this.searchValue}`
          );
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //搜索
    search() {
      this.getData(
        `Service_Display_Exhibit?themeId=${this.themeId}&title=${this.searchValue}`
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-exhibit/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
				this.ResetSearch(["searchValue"]);

                this.getData(
                  `Service_Display_Exhibit?themeId=${this.themeId}&page=${this.currentPage}&title=${this.searchValue}`
                );
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(
                  `${urlConfig.devUrl}apij2/admin-api/trade/service-display-exhibit/batchDelete?ids=` + this.deleteRow,
                "",
                "delete"
              )
              .then((res) => {
                if (res.code == 0) {
				this.ResetSearch(["searchValue"]);

                  this.getData(
                    `Service_Display_Exhibit?themeId=${
                      this.themeId
                    }&page=${1}&title=${this.searchValue}`
                  );
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的展品",
        });
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.getData(
        `Service_Display_Exhibit?themeId=${this.themeId}&page=${val}&title=${this.searchValue}`
      );
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.fileList.push({
                name: file.name,
                url: this.imgUrl + res.data,
                store_result: res.data,
                uid: file.uid,
              });
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    //移除
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@include component(exhibition) {
  width: 100%;
  height: 100%;
  /deep/.el-tag {
    &:hover {
      cursor: pointer;
    }
  }
  .exhibition-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .exhibition-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }
  .exhibition-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 200px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
